export const GET_ALL_SYSTEM_SETTINGS = null;
export const SELECTED_ADDON_LOGIN_DETAILS = null;
export const GET_ORGANIZATION_TOP_LISTING_SUBSCRIPTION_PLAN_LIST = null;
export const SELECTED_PUSH_NOTIFICATION_DETAILS = null;